const employees = [
  '1 a 50',
  '51 a 100',
  '101 a 500',
  '501 a 1000',
  'mais de 1000',
];

export default employees;